export default __webpack_public_path__ + "static/media/1932.5dddfa7e.png";